// removed by extract-text-webpack-plugin
module.exports = {"vpQuestionTitle":"vpQuestionTitle___3BqCQ","vpQuestionDescription":"vpQuestionDescription___eQ38O","vpTogglePreview":"vpTogglePreview___14tX7","vpQuestionSeparator":"vpQuestionSeparator___IjG39","vpRequiredLabel":"vpRequiredLabel___3RQrH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/FullQuestion.module.less
// module id = 2574
// module chunks = 29